import type { SanityPageBuilderInfoCardsCard, SanityPageBuilderInfoCardsSection, SanityPageBuilderSection } from "@ouster/shared";
import { InfoCardsBlockView } from "~/features/blocks/inventory/info-cards";
import { InfoCardsCardView, type InfoCardsCardViewProps } from "~/features/blocks/inventory/info-cards/card";
import { SanityMediaFigure, hasRenderableSanityMedia } from "~/features/sanity/page-builder/sections/media-figure";
import { SanityRichText } from "~/features/sanity/rich-text";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderInfoCardsSection;
  };
};
type InfoCardsViewCard = Omit<InfoCardsCardViewProps, "ratio"> & Pick<SanityPageBuilderInfoCardsCard, "_key">;
export function SanityInfoCardsSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const cards = sectionContent.cards?.map<InfoCardsViewCard>(card => ({
    _key: card._key,
    description: card.description?.length ? <SanityRichText value={card.description} /> : undefined,
    media: hasRenderableSanityMedia(card.media) ? <SanityMediaFigure media={card.media} ratio="1/1" fit="cover" /> : undefined,
    title: card.title,
    url: card.url
  })) ?? [];
  return <InfoCardsBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} cards={cards} getCardKey={(card, index) => card._key || index} hasTopDivider={sectionSettings?.hasTopDivider ?? true} headline={sectionContent.headline} isHighlighted={sectionContent.isHighlighted} mode={sectionSettings?.mode || "light"} renderCard={(card, _index, ratio) => <InfoCardsCardView {...card} ratio={ratio} />} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} theme={sectionSettings?.theme || "white"} />;
}